import { Clock, LogOut, DollarSign, LifeBuoy } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { VideoHistoryList } from "@/components/video/VideoHistoryList";
import { Link, useLocation, useNavigate } from "react-router-dom";

interface DesktopMenuProps {
  onSignOut: () => Promise<void>;
}

export const DesktopMenu = ({ onSignOut }: DesktopMenuProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handlePricingClick = () => {
    if (location.pathname === '/landing') {
      const element = document.getElementById('pricing');
      element?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate('/pricing');
    }
  };

  return (
    <div className="hidden md:flex items-center gap-3">
      <Sheet>
        <SheetTrigger asChild>
          <Button 
            variant="ghost" 
            size="sm"
            className="gap-2 transition-all duration-300 hover:bg-primary/10 min-h-[44px]"
          >
            <Clock className="h-4 w-4" />
            History
          </Button>
        </SheetTrigger>
        <SheetContent className="w-[400px] sm:w-[540px]">
          <SheetHeader>
            <SheetTitle>Video History</SheetTitle>
          </SheetHeader>
          <div className="mt-6 space-y-4">
            <VideoHistoryList />
          </div>
        </SheetContent>
      </Sheet>

      <Button 
        onClick={handlePricingClick}
        variant="ghost"
        size="sm"
        className="gap-2 transition-all duration-300 hover:bg-primary/10 min-h-[44px]"
      >
        <DollarSign className="h-4 w-4" />
        Pricing
      </Button>

      <Link to="/support">
        <Button 
          variant="ghost"
          size="sm"
          className="gap-2 transition-all duration-300 hover:bg-primary/10 min-h-[44px]"
        >
          <LifeBuoy className="h-4 w-4" />
          Support
        </Button>
      </Link>

      <Button 
        onClick={onSignOut} 
        variant="ghost"
        size="sm"
        className="gap-2 transition-all duration-300 hover:bg-primary/10 min-h-[44px]"
      >
        <LogOut className="h-4 w-4" />
        Sign Out
      </Button>
    </div>
  );
};